define('drops/drawings/runtimeTypesProvider',[
    'lq/typesProvider',

    './flow/flow',
    './gateway/gateway',
    './milestone/milestone',
    './start/start',
    './stop/stop',
    './task/task'
], function (TypesProvider) {
    'use strict';

    var dropTypes = Array.prototype.slice.call(arguments, 1);
    return new TypesProvider(dropTypes);
});
